module.exports = __webpack_public_path__ + "files/6412803e1298a4fd8775099dfabc8ccf.svg";